export default __webpack_public_path__ + "static/media/markerPolylineGreen.7f180ffb.svg";